import {MEETING_MANAGER_PATH} from '../constants';

export const getIsMeetingManagerPath = (
    urlPath: string = location.pathname,
) => {
    return (
        urlPath.endsWith(`/${MEETING_MANAGER_PATH}`) ||
        urlPath.endsWith(`/${MEETING_MANAGER_PATH}/`)
    );
};
